import {
  AfterViewInit,
  Component,
  effect,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ProgressBarOverlayComponent } from 'src/app/components/progress-bar-overlay/progress-bar-overlay.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { Azienda, AziendaService } from 'src/app/services/azienda/azienda.service';
import { BucketService } from 'src/app/services/bucket/bucket.service';
import { BucketStoreService } from './bucket-store.service';
import { DialogInfoDocumentoComponent } from './documenti-components/dialog-crea-cartella/dialog-info-documento/dialog-info-documento.component';
import { DialogSpiegazioneGestioneDocumentaleComponent } from './documenti-components/dialog-spiegazione-gestione-documentale/dialog-spiegazione-gestione-documentale.component';
import { FolderTreeComponent } from './documenti-components/folder-tree/folder-tree.component';

@Component({
  selector: 'app-bucket-documenti',
  standalone: false,

  templateUrl: './bucket-documenti.component.html',
  styleUrl: './bucket-documenti.component.scss',
})
export class BucketDocumentiComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(FolderTreeComponent) folderTree!: FolderTreeComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild(ProgressBarOverlayComponent, { static: true })
  progressBarOverlay!: ProgressBarOverlayComponent;

  private _subAziendaCorrente: Subscription | undefined;
  private azienda: Azienda | undefined = undefined;
  private readonly _store = inject(BucketStoreService);
  public showError: boolean = false;

  get listaFolders() {
    if (this._store.tree()) {
      return this._store.tree();
    }
    return [];
  }

  get errorCaricamento() {
    return this._store.error();
  }

  get selectedFolderEmpty() {
    const folder = this._store.selectedFolder();
    return !folder?.files?.length;
  }

  get folderSelezionato() {
    return this._store.selectedFolder();
  }

  constructor(
    private readonly _bucketService: BucketService,
    private readonly aziendaService: AziendaService,
    private readonly dialog: MatDialog,
  ) {}
  public searchValue = '';

  ngOnInit(): void {
    this._store.loadFolders();
  }

  ngAfterViewInit() {
    this._onChangeAzienda();
  }

  ngOnDestroy(): void {
    this._subAziendaCorrente?.unsubscribe();
    this._store.clearSignal();
  }

  /**
   * Effect che osserva lo stato di caricamento dal store e aggiorna
   * la progress bar di conseguenza.
   *
   * Funzionamento:
   * - Se `loading?.isLoad` è true, mostra la progress bar con il messaggio `loading.msg`.
   * - Se `loading` è null/undefined o `isLoad` è false, nasconde la progress bar.
   *
   * Nota su `@ViewChild` e `static`:
   * - La proprietà `progressBarOverlay` viene definita con `@ViewChild(ProgressBarOverlayComponent, { static: true })`.
   * - `static: true` significa che Angular risolve il riferimento al componente **prima** di `ngOnInit`, rendendolo disponibile anche
   *   per l'effect definito come proprietà della classe.
   * - Se `static: false`, `progressBarOverlay` sarebbe disponibile solo dopo `ngAfterViewInit`, e l'effect iniziale potrebbe
   *   trovare `undefined`.
   *  ATTENZIIONE: lo statoc funziona solamente se il componente non è condizionato da un @if
   */
  loadingEffect = effect(() => {
    const loading = this._store.loading();
    if (loading?.isLoad) {
      this.progressBarOverlay?.show(loading.msg);
    } else {
      this.progressBarOverlay?.hide();
    }
  });

  /**
   * Se ho un errore nel caricamento dei folder
   */
  effectError = effect(() => {
    const errore = this._store.error();
    this.showError = !!errore;
  });

  private _onChangeAzienda() {
    this._subAziendaCorrente = this.aziendaService.aziendaCorrente.subscribe((azienda) => {
      let cambiato = false;

      if (this.azienda && azienda && this.azienda.id !== azienda.id) {
        cambiato = true;
      }

      this.azienda = azienda;

      if (cambiato) {
        this._store.loadFolders();
      }
    });
  }

  protected apriListaEsaustiva() {
    const dialog = this.dialog.open(DialogSpiegazioneGestioneDocumentaleComponent, {
      data: {},
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '50%',
      height: '90%',
      autoFocus: false,
    });

    dialog.afterClosed().subscribe(() => {});
  }

  /**
   * Aggiunta di folder e edit
   * @param folder
   */

  onNewFolder(isCreazione: boolean) {
    const parentFolder = this.folderSelezionato;
    if (parentFolder) {
      this._store.creaFolder(parentFolder, isCreazione).subscribe();
    }
    this._store.updateScrollbar();
  }

  /**
   * Importazione File
   */
  public async onUploadFile(files: FileList) {
    // Il browser ritorna un tipo FileList devo convertilo in array File per lavorarlo
    const filesArray: File[] = Array.from(files);
    await this._store.importaFile(filesArray);
    this._store.updateScrollbar();
  }

  public onInfoFileFolder() {
    const dialogCreaFolder = this.dialog.open(DialogInfoDocumentoComponent, {
      data: { fileFolder: this.folderSelezionato },
      disableClose: false,
      width: '30%',
      height: 'auto',
      autoFocus: false,
    });

    return dialogCreaFolder.afterClosed().pipe();
  }

  onDeleteFolder() {
    if (this.folderSelezionato) {
      this._store.eliminaFolder(this.folderSelezionato);
    }
    this._store.updateScrollbar();
  }
}
